import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import AssetRegisterComp from './AssetRegisterComp'

function AssetRegister() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <AssetRegisterComp/>      
        </div>
    </div>
  )
}

export default AssetRegister